import type { PortalGateway } from './hooks/usePaymentGateways'

/** Monedas elegibles de una pasarela (las permitidas, o la del catálogo). */
export function currencyOptionsFor(
  gateway: PortalGateway | undefined,
  fallbackCurrency?: { id: number; name: string } | null,
): { id: number; name: string }[] {
  if (!gateway) return []
  if (gateway.allowedCurrencies.length > 0) return gateway.allowedCurrencies
  return fallbackCurrency ? [fallbackCurrency] : []
}
